import * as React from 'react';
import { TaskDisplay } from '@centecomm/portal-service';
import { useUserTasks } from '@centecomm/portal-service-react';
import { addDays } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { IconProps } from '../../Icons/IconProps';

interface Properties {
    task: TaskDisplay;
    text?: string;
    Icon?: React.FC<IconProps>;
    clearReminder: () => void;
}

const PauseTask: React.FC<Properties> = ({ task, text, Icon, clearReminder }): React.ReactElement => {
    const { t } = useTranslation(['tasks']);
    const { pauseTask } = useUserTasks();
    const pauseUntil = new Date(addDays(Date.now(), 7));

    const pauseTaskHandler = async () => {
        try {
            await pauseTask(task.id, task.type, pauseUntil);
        } catch (e) {
            // Ignore, as I don't think it is necessary to have an error message for this type of action
            // On the off chance the api call fails, the user will just simply see the reminder again on
            // refresh
        } finally {
            clearReminder();
        }
    };

    return (
        <div>
            {/* eslint-disable-next-line max-len */}
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, jsx-a11y/anchor-is-valid */}
            <a onClick={pauseTaskHandler}>{Icon ? <Icon aspect="1rem" /> : text || t('tasks:pauseTask.remindMeLater')}</a>
        </div>
    );
};

export default PauseTask;
